import React, { useEffect, useRef, useState } from 'react';
import { fill } from './labels';

// Email-only for now: app/services/wa/ carries a single hardcoded OTP sender and no
// general template endpoint, so the WhatsApp channel is shown disabled (plan gap G8).
export default function ReminderModal({ pendingCount, date, onClose, onSubmit, labels }) {
  var [submitting, setSubmitting] = useState(false);
  var [error, setError] = useState(null);
  var dialogRef = useRef(null);

  useEffect(function () {
    function onKeyDown(event) {
      if (event.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', onKeyDown);
    if (dialogRef.current) dialogRef.current.focus();
    return function () { document.removeEventListener('keydown', onKeyDown); };
  }, [onClose]);

  function handleSubmit() {
    setSubmitting(true);
    setError(null);
    Promise.resolve(onSubmit()).
      catch(function () { setError(labels.failed); }).
      then(function () { setSubmitting(false); });
  }

  return (
    <div className="ehc-monitoring__modal-backdrop" onClick={onClose} role="presentation">
      <div
        className="ehc-monitoring__modal"
        role="dialog"
        aria-modal="true"
        aria-label={labels.title}
        tabIndex={-1}
        ref={dialogRef}
        onClick={function (event) { event.stopPropagation(); }}
      >
        <div className="ehc-monitoring__modal-header">
          <h5>{labels.title}</h5>
          <p className="ehc-monitoring__sub">{fill(labels.sub, { count: pendingCount, date: date })}</p>
        </div>

        <div className="ehc-monitoring__modal-body">
          <span className="ehc-monitoring__field-label">{labels.channel_label}</span>

          <label className="ehc-monitoring__channel" htmlFor="ehc-reminder-email">
            <input type="radio" id="ehc-reminder-email" name="ehc-reminder-channel" defaultChecked />
            <span>
              <strong>{labels.channel_email}</strong>
              <small>{fill(labels.channel_email_sub, { count: pendingCount })}</small>
            </span>
          </label>

          <label className="ehc-monitoring__channel ehc-monitoring__channel--disabled" htmlFor="ehc-reminder-wa">
            <input type="radio" id="ehc-reminder-wa" name="ehc-reminder-channel" disabled />
            <span>
              <strong>{labels.channel_whatsapp}</strong>
              <small>{labels.channel_whatsapp_disabled}</small>
            </span>
          </label>

          <p className="ehc-monitoring__note">{labels.note}</p>
          {error && <p className="text-danger mb-0">{error}</p>}
        </div>

        <div className="ehc-monitoring__modal-footer">
          <button type="button" className="btn btn-link" onClick={onClose} disabled={submitting}>
            {labels.cancel}
          </button>
          <button type="button" className="btn btn-primary" onClick={handleSubmit} disabled={submitting}>
            {labels.submit}
          </button>
        </div>
      </div>
    </div>
  );
}
